import { useCallback } from 'react';
import { showErrorMessage } from '../../../../utils/messages';
import { apiGetFileAttachment } from '../api/get-file-attachment';

export default function FileAttachmentLink(props: {
	caption: string, fileName: string, awsS3Key: string
}) {

	const downloadFile = useCallback(async (e: any, fileName: string, awsS3Key: string) => {
		e.preventDefault();

		await apiGetFileAttachment(fileName, awsS3Key)
			.then((result) => {
				if (result.isSuccess) {
					window.open(result.url);
				}
				else {
					showErrorMessage(result.errorMessage!);
				}
			})
			.catch((reason) => {
				showErrorMessage(reason);
			});
	}, []);

	return (
		<a href="" target="_blank" className="file-attachment-link"
			onClick={(e) => downloadFile(e, props.fileName, props.awsS3Key)}>
			{props.caption}
		</a>
	)
}
